<template lang="pug">
.drugstore.cursor-pointer.q-pa-md(
    @click="buttonClick"
    ref="drugstoreItem"
    :class="active ? 'bordered-positive' : ''")
    .row.items-start.relative-position
        q-btn.absolute-top-right(
            v-if="userAuthorized"
            flat
            fab-mini
            style="top: -4px; right: -8px;"
            @click.prevent.stop="updateFavourite")
            q-icon(
                name="etabl:heart"
                size="20px"
                dense
                :color="isFavourite ? 'negative' : 'grey-7'")
        .col-12
            .row.items-center.q-mb-sm
                q-img(
                    v-if="drugstore.brandUrl"
                    :src="drugstore?.brandUrl"
                    style="max-width: 85px; height: 44px"
                    fit="contain"
                )
                q-img(
                    v-else
                    src="logo_t.t.svg"
                    style="max-width: 85px; height: 44px"
                    fit="contain"
                )
                .font-16.text-weight-600.q-ml-md
                    | {{ drugstore?.title ? drugstore?.title : 'Табле.Точка' }}
            .font-16.text-weight-medium.q-mb-xs(v-if="appointment")
                | {{  drugstore.city.name }}
            .drugstore__address.flex.items-center.no-wrap
                q-icon(
                    v-if="!appointment"
                    name="etabl:location-marker"
                    color="positive"
                    size="16px"
                ).q-mr-sm
                .text-weight-medium.text-positive(v-if="!appointment" style="max-width: 331px")
                    | {{ drugstore.geo.address }}
                .text-primary(v-else)
                    | {{ drugstore.address }}
            .font-15.q-mt-sm(v-if="!currentDrugstoreSchedule && !appointment") График работы:
                strong.text-positive Круглосуточно
            q-expansion-item(
                v-if="currentDrugstoreSchedule && !appointment"
                :label="`График работы: ${currentDrugstoreSchedule}`"
                header-class="font-14")
                .row.justify-between
                    .day.q-pa-xs.text-center(
                        v-for="(day, index) in drugstore.schedule"
                        :key="index"
                        :class="day.day === today ? 'bordered-positive b-radius-8' : ''"
                        :style="day.day === today ? 'background-color: rgba(231, 247, 232, 0.4)' : ''")
                        .text-positive.font-14 {{ day.dayName }}
                        .text-primary.font-12 {{ day.start ? day.start.slice(0, 5) : '' }}
                        .text-primary.font-12 {{ day.end ? day.end.slice(0, 5) : '' }}
                        .text-primary.font-12(v-if="!day.start") Вых.

            .q-mt-sm(v-if="appointment" style="width: 175px;")
                base-btn(
                    width="206"
                    height="40"
                    font_size="14"
                    color="positive"
                    bradius="16"
                    :disable="!drugstore.isReceptionAvailable"
                    loading_color="secondary"
                    :label="drugstore.isReceptionAvailable ? 'Выбрать этот салон' : 'Запись недоступна'"
                    @click="setDrugstore")
            .row.items-center.no-wrap.q-mt-sm(v-if="addressSet && !appointment" :style="'gap: 8px'")
                base-btn(
                    height="40"
                    font_size="14"
                    color="positive"
                    bradius="16"
                    loading_color="secondary"
                    label="Искать в этой аптеке"
                    @click="setAddress")
                base-btn(
                    :width="'250'"
                    :label="'Маршрут'"
                    :height="'40'"
                    :background="'transparent'"
                    :text_color="'positive'"
                    :outline="true"
                    :icon="'near-me'"
                    :icon_color="'positive'"
                    font_size="14"
                    bradius="16"
                    centred
                    :gapLabel="'8px'"
                    @click="getRouteToPharmacy(drugstore.geo.location)"
                )


        .full-width.text-dark.transition-all(
            v-if="basket"
            @click="show = !show"
            style="padding-right: 7px;")
            .row.items-center
                .col-grow.row.justify-between.q-mt-sm
                    slot(name="bages")
                q-icon.q-ml-lg.q-mt-xs(
                    :color="show ? 'positive' : 'grey-12'"
                    name="etabl:arrow_down"
                    size="11px"
                    :class="[show ? 'rotate-180' : '', 'transition-all']")
            q-slide-transition(:duration="200")
                div(v-show="show")
                    .row.font-12.text-weight-regular.q-py-xs(
                        v-for="item in drugstore.list_items")
                        .col-6.text-grey-11.text-ellipsis {{ item.name }}
                        .col-2.text-grey-9.text-center {{ item.available }} / {{ item.amount }}
                        .col-4.app-primary.text-right.text-weight-bold
                            | В аптеке {{ item.price }} ₽
                    template(v-if="drugstore.list_not_available?.length")
                        .font-12.text-weight-bold {{ methodWayGet[0] === 2 ? 'Заказать со склада' : 'Недоступны для заказа со склада' }}
                        .row.font-12.text-weight-regular.q-py-xs(v-for="item in drugstore.list_not_available")
                            .col-6.text-grey-11.text-ellipsis {{ item.name }}
        .row.items-center.col-grow(v-else)
            slot(name="bages")
            base-btn.q-mt-md(
                v-if="!addressSet"
                :label="'Маршрут'"
                :height="'40'"
                :background="'transparent'"
                :text_color="'positive'"
                :outline="true"
                :icon="'near-me'"
                :icon_color="'positive'"
                font_size="14"
                bradius="16"
                centred
                :gapLabel="'8px'"
                @click="getRouteToPharmacy(drugstore.geo.location)"
            )
</template>

<script>
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import BaseBtn from 'components/Base/BaseBtn.vue';
import { useRoute } from 'vue-router';

export default {
    name: 'DrugstoreListProductDesktop',
    emits: ['click'],
    components: {
        BaseBtn,
    },
    props: {
        drugstore: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: () => false,
        },
        cityName: {
            type: String,
            default: () => null,
        },
        address: {
            type: String,
            default: () => null,
        },
        index: {
            type: Number,
        },
        length: {
            type: Number,
        },
        accessScroll: {
            type: Boolean,
        },
        basket: {
            type: Boolean,
        },
        userFavouriteDrugstores: {
            type: Array,
        },
        appointment: {
            type: Boolean,
            default: () => false,
        },
        addressSet: {
            type: Boolean,
            default: () => false,
        },
    },
    setup(props, { emit, slots }) {
        const store = useStore();
        const route = useRoute();
        const timer = ref();
        const show = ref(false);
        const drugstoreItem = ref(null);
        const today = computed(() => new Date().getDay());

        const isFavourite = computed(() => props.userFavouriteDrugstores?.includes(props.drugstore.id));
        // const isFavourite = ref(false);


        const userAuthorized = computed(() => store.getters['user/USER_AUTHORIZED']);
        const slotPassed = computed(() => !!slots.bages);

        // значение "забрать сегодня"
        const isToday = computed(() => store.getters['basket/BASKET_IS_TODAY']);

        // способ получения
        const methodWayGet = computed(() => store.getters['basket/BASKET_METHOD_WAY_GET']);

        watch(() => props.active, (value) => {
            if (value) {
                setPosition();
            }
        });

        const updateFavourite = async () => {
            if (timer.value) {
                clearTimeout(timer.value);
            }

            timer.value = setTimeout(async () => {
                isFavourite.value
                    ? deleteDrugstoreFromUserFav()
                    : addDrugstoreToUserFav();
                emit('changedFavourites');
            }, 300);
        };

        const deleteDrugstoreFromUserFav = async () => {
            try {
                await store.dispatch('user/DELETE_FAVOURITE_DRUGSTORE', props.drugstore.id);
                await store.commit('user/DELETE_USER_FAVOURITE_DRUGSTORE', props.drugstore.id);
            } catch (e) {
                console.log(e);
            }
        };

        const addDrugstoreToUserFav = async () => {
            try {
                await store.dispatch('user/ADD_FAVOURITE_DRUGSTORE', props.drugstore.id);
                await store.commit('user/ADD_USER_FAVOURITE_DRUGSTORE', props.drugstore);
            } catch (e) {
                console.log(e);
            }
        };

        // время работы выбранной аптеки
        const currentDrugstoreSchedule = computed(() => {
            let day;

            if (props.drugstore.schedule?.length)
                if (today.value > 0) {
                    day = props.drugstore.schedule
                        .find((item) => item.day === today.value);
                } else if (today.value === 0) {
                    day = props.drugstore.schedule
                        .find((item) => item.day === 7);
                }

            if (props.drugstore.schedules?.length)
                if (today.value > 0) {
                    day = props.drugstore.schedules
                        .find((item) => item.dayNumber === today.value);
                } else if (today.value === 0) {
                    day = props.drugstore.schedule
                        .find((item) => item.dayNumber === 7);
                }

            const formatTime = (time) => time?.slice(0, 5);

            if (day && props.appointment) {
                if (!day.workingTime.begin) {
                    return 'Выходной';
                }
                if (day.workingTime.begin === '00:00') {
                    return false;
                } else {
                    return `Сегодня ${formatTime(day.workingTime.begin)} - ${formatTime(day.workingTime.end)}`;
                }
            }

            if (day) {
                if (!day.start) {
                    return 'Выходной';
                }
                if (day.start === '00:00') {
                    return false;
                } else {
                    return `Сегодня ${formatTime(day.start)} - ${formatTime(day.end)}`;
                }
            }
            return null;
        });

        const setPosition = () => {
            if (props.accessScroll)
                emit('setPosition', drugstoreItem.value.offsetTop);
        };

        const setDrugstore = async () => {
            emit('setAppointment', props.drugstore);
        };

        const setAddress = () => {
            emit('setAddress', props.drugstore);
        };

        const expansionColor = computed(() => {
            return '#0CA551';
        });

        const buttonClick = () => {
            emit('clickDrugstore', props.drugstore);
        };

        const getRouteToPharmacy = (location)=>{

            try {
                if(route.name === 'Product'){
                    ym(72234883,'reachGoal','product-directions-click');
                }else {
                    ym(72234883,'reachGoal','click-route-addressMap');

                }
            }catch (err){

            }
            window.open(`https://yandex.ru/maps?rtext=~${location.lat},${location.lon}&rtt=auto`, '_blank');

            //window.open(`https://yandex.ru/maps/?mode=routes&rtext=~${location.lat}%2C${location.lon}rtt=auto&ruri=~&z=12`, '_blank');
        };

        onMounted(() => {
            if (props.active) {
                setPosition();
            }
        });

        return {

            show,
            today,
            slotPassed,
            buttonClick,
            isFavourite,
            setDrugstore,
            methodWayGet,
            drugstoreItem,
            userAuthorized,
            updateFavourite,
            currentDrugstoreSchedule,
            expansionColor,
            setAddress,
            getRouteToPharmacy,
        };
    },
};
</script>

<style lang="scss" scoped>
.drugstore {
    color: $primary;
    margin: 0 10px 10px;
    border-radius: $mobile-border-radius;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    background: white;

    @media (max-width: 960px) {
        padding: 14px 24px;
    }
    @media screen and (max-width: $breakpoint-mobile) {
        padding: 0 4px;
    }

    &-active {
        color: $positive;
    }

    &__address {
        @media (max-width: 1280px) {
            font-size: 14px !important;
        }
        @media screen and (max-width: $breakpoint-mobile) {
            font-weight: 600;
        }
    }

    &__city {
        @media (max-width: 960px) {
            font-size: 14px !important;
        }
    }

    &__schedule {
        @media (max-width: 960px) {
            font-size: 12px !important;
        }
    }
}

:deep(.q-expansion-item) {
    .q-item {
        font-size: 14px;
        min-height: 0;
        padding: 4px 0;

        .q-focus-helper {
            display: none;
        }

        .q-item__section--side {
            color: $positive;
        }
    }
}
</style>
